import React, { SyntheticEvent } from 'react';

import ChatButtonView from './ChatButtonView';

import { useChatState } from '../../../../../hooks/context';
import { useMytaverseEvent } from '../../../providers';
import { AnalyticsType } from '../../../../../interfaces/analytics';

const ChatButton = () => {
  const { setOpen, isUnreadEventChannel, isUnreadPrivateChannel } =
    useChatState();
  const { trackEventAnalytics } = useMytaverseEvent();

  return (
    <ChatButtonView
      handleClick={(event: SyntheticEvent<HTMLButtonElement>) => {
        setOpen(true);
        event.currentTarget.blur();
        trackEventAnalytics(AnalyticsType.ChatOpen);
      }}
      showUnreadIcon={isUnreadEventChannel || isUnreadPrivateChannel}
    />
  );
};

export default ChatButton;
